import gql from 'graphql-tag';

export const QUERY_PLP_CATEGORY = gql`
  query GetPLPCategory($categorySlug: String!) {
    searchProductCategories(where: { slug: $categorySlug }) {
      id
      name_en
      name_de
      description_en
      description_de
      meta_title_en
      meta_title_de
      meta_description_en
      meta_description_de
      slug
      image {
        url
        alternativeText
      }
    }
  }
`;

export const QUERY_PLP_FILTERS = gql`
  query GetPLPFilters($categorySlug: String!) {
    searchProductCategories(where: { slug: $categorySlug }) {
      id
      name_en
      name_de
      description_en
      description_de
      meta_title_en
      meta_title_de
      meta_description_en
      meta_description_de
      slug
      image {
        url
        alternativeText
      }
      product_subcategories {
        id
        name_en
        name_de
        slug
      }
    }
    locationTypes: searchLocationTypes(where: { key_null: false }) {
      id
      name_en
      name_de
      slug
    }
    designers {
      id
      name
      slug
    }
  }
`;
